import { useState } from "react";
import { Layers, Loader2, Plus, X } from "lucide-react";
import type { OfertaDeMaterial } from "./MateriaisECoresDoServico";

/** Título de "Materiais compatíveis" com o "Novo material", e os já marcados em etiquetas com X
 *  — dá pra ver e tirar o que está marcado sem abrir família por família. */
export function CabecalhoDosMateriais({
  marcados,
  onTirar,
  onNovoMaterial,
  criandoMaterial,
}: {
  marcados: OfertaDeMaterial[];
  onTirar: (id: string) => void;
  onNovoMaterial: (nome: string) => Promise<unknown> | void;
  criandoMaterial?: boolean;
}) {
  const [criando, setCriando] = useState(false);
  const [nome, setNome] = useState("");

  const adicionar = async () => {
    try {
      await onNovoMaterial(nome.trim());
    } catch {
      return; // quem cria já avisou o erro; o nome fica no campo pra tentar de novo
    }
    setNome("");
    setCriando(false);
  };

  return (
    <div className="mb-2 space-y-2">
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-600 dark:bg-primary/10 dark:text-primary">
            <Layers className="h-4 w-4" />
          </span>
          <div>
            <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">Materiais compatíveis</p>
            <p className="text-xs text-zinc-500 dark:text-muted-foreground">Os que o dentista poderá escolher no pedido.</p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setCriando((v) => !v)}
          className="inline-flex shrink-0 items-center gap-1 text-xs font-semibold text-brand-700 hover:underline dark:text-primary"
        >
          <Plus className="h-3.5 w-3.5" />
          Novo material
        </button>
      </div>

      {criando && (
        <div className="flex gap-1.5">
          <input
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && nome.trim().length >= 2 && void adicionar()}
            placeholder="Ex: Zircônia HT"
            aria-label="Nome do material novo"
            autoFocus
            className="h-9 flex-1 rounded-md border border-zinc-200 bg-white px-3 text-sm text-zinc-900 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground"
          />
          <button
            type="button"
            disabled={nome.trim().length < 2 || criandoMaterial}
            onClick={() => void adicionar()}
            className="inline-flex h-9 items-center gap-1 rounded-md bg-brand-600 px-3 text-xs font-semibold text-white disabled:opacity-50"
          >
            {criandoMaterial ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : null}
            Adicionar
          </button>
        </div>
      )}

      {marcados.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {marcados.map((m) => (
            <button
              key={m.id}
              type="button"
              onClick={() => onTirar(m.id)}
              aria-label={`Tirar ${m.label}`}
              className="inline-flex items-center gap-1 rounded-md bg-brand-50 px-2 py-1 text-xs font-medium text-brand-700 hover:bg-brand-100 dark:bg-primary/10 dark:text-primary"
            >
              {m.label}
              <X className="h-3 w-3" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
